const MIN_SYMBOL_SIZE = 10
const MAX_SYMBOL_SIZE = 15

export default function Config(color, dataset = []) {
  let max = 0
  let min = 0
  dataset.forEach((data) => {
    max = Math.max(max, data.value[2])
    min = Math.min(min, data.value[2])
  })
  const diff = (max - min) || 1
  const config = {
    backgroundColor: 'transparent',
    color,
    tooltip: {
      show: true,
      trigger: 'item',
      formatter(params) {
        return `
          ${params.marker} ${params.data.name}  ${params.data.value[2]?.toLocaleString()}
          
        `
      }
    },
    grid: {
      containLabel: true,
      top: 20,
      right: 0,
      bottom: 0,
      left: 0,
    },
    geo: {
      map: 'china',
      zoom: 1.2,
      emphasis: {
        label: {
          show: false
        }
      },
      itemStyle: {
        // 普通状态下的样式
        normal: {
          areaColor: 'rgba(47, 84, 235, 0.1)',
          borderColor: '#fff'
        },
        emphasis: {
          areaColor: 'rgba(47, 84, 235, 0.1)',
        }
      }
    },
    series: [{
      type: 'scatter',
      coordinateSystem: 'geo',
      data: dataset,
      symbolSize: (val) => {
        const crtDiff = val[2] - min
        const ratio = crtDiff / diff

        return MIN_SYMBOL_SIZE + ((MAX_SYMBOL_SIZE - MIN_SYMBOL_SIZE) * ratio)
      }
    }]
  }
  return config
}
